module.exports = __webpack_public_path__ + "img/bg_阴影@3x.6b704d7d.png";